module.exports = __webpack_public_path__ + "img/pen.eaded72a.png";